import React, { ReactElement, useState } from 'react';
import { Form, Input, Button, Checkbox, Row, Col, Grid } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { CustomButton } from '../../Shared/Button/CustomButton';
import PdfEncryptImage from '../../../assets/pdffEncrypt.svg';
import './PasswordManage.styles.css';

const { useBreakpoint } = Grid;

const defaultProps = {};
type PasswordManagerProps = {
	onPasswordChange: (e: any) => void;
	onSubmit: () => Promise<void>;
	fileName: string;
} & typeof defaultProps;

export const PasswordManager = ({
	onPasswordChange,
	onSubmit,
	fileName
}: PasswordManagerProps): ReactElement => {
	const { md, xs, sm } = useBreakpoint();
	return (
		<Row
			style={{
				width: '100%',
				textAlign: 'center'
			}}>
			<Col xl={7} xs={24} md={7}>
				<img
					src={PdfEncryptImage}
					alt='Pdf Encrypt Image'
					width='40%'
				/>
				<h2>{fileName}</h2>
			</Col>
			<Col xl={7} xs={24} md={7}>
				<p
					className={`encrypt-details-input ${
						md || sm || xs ? 'x-centered' : ''
					}`}>
					We protect your file with strong 128-bit AES encryption.
					This will make it impossible to open or remove the
					protection without the correct password. So, don't forget
					it! We don't keep your password or your file on our server.
					For more information please read our privacy policy
				</p>
			</Col>
			<Col xl={9} xs={24} md={10}>
				<Form
					name='normal_login'
					className='login-form'
					initialValues={{ remember: true }}

					// onFinish={onFinish}
				>
					<Form.Item
						name='password'
						rules={[
							{
								required: true,
								message: 'Please input your Password!'
							}
						]}>
						<Input
							prefix={
								<LockOutlined className='site-form-item-icon' />
							}
							name='password'
							style={{ height: '45px', width: '100%' }}
							type='password'
							placeholder='Password'
							onChange={onPasswordChange}
						/>
					</Form.Item>
					<Form.Item
						name='submit'
						rules={[
							{
								required: true,
								message: 'Passwords does not match'
							}
						]}>
						<Input
							prefix={
								<LockOutlined className='site-form-item-icon' />
							}
							name='confirmPassword'
							type='password'
							placeholder='Confirm Password'
							style={{ height: '45px', width: '100%' }}
							onChange={onPasswordChange}
						/>
					</Form.Item>

					<Form.Item>
						<CustomButton title='ENCRYPT PDF' onClick={onSubmit} />
					</Form.Item>
				</Form>
			</Col>
		</Row>
	);
};
PasswordManager.defaultProps = defaultProps;
